export default __webpack_public_path__ + "static/media/cart.a7619eb3.svg";